import React, { FC } from 'react'

export type VidePlayerPlaceholderProps = {
  title: string
  thumbnail: string
}
export const VideoPlayerPlaceholder: FC<VidePlayerPlaceholderProps> = ({
  title,
  thumbnail,
}) => {
  return (
    <div className="relative w-full h-full">
      <div className="relative w-full pb-[56.25%] h-auto overflow-hidden">
        <img
          className="absolute top-0 left-0 right-0 w-full h-auto"
          src={thumbnail}
          alt={title}
          width="480"
          height="270"
        />
      </div>
      <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center w-full h-full"></div>
    </div>
  )
}
